import styled from 'styled-components';

export const SectionTitle = styled.div``;

export const Title = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;
    @media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
  }
  @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
  }
  @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
  }
`;

export const ProfileTabViewSection = styled.section`
    
    .search-banner-view{
        background: #fff;
        padding: 40px 30px;
        border-radius: 15px;
        margin-bottom: 30px;
          @media screen and (max-width:575px) {
           padding: 30px 20px;
          }
    
    }

    .right-side-banner,
    .warm-cost-wrapper{
        display: none;
    }
    .non-profit-details-text-two{
        padding-top: 7px;
    }
    
    .contact-detail-list,
    .donation-social-media-btn,
    .non-profit-details-text,
    .non-profit-causes{
        display: none;
    }

    .donor-volunteer-advisory-wrap{
        display: block;
    }

    .heart-button {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px 10px;
        margin-top: 10px;
    }
    
    .top-rated-wrap-box{
        background: #99C8C880;
        .top-rated-logo{
            display: none;
        }
        .btn-outline-success-blue{
            width: 100%;
            margin-top: 20px;
            padding: 12px 20px;
        }
    }

    .donation-box-wrapper{
        .donate-image-col-box{
            margin-bottom: 0px;
        }
        .client-message{
            background: #fff;
            padding-bottom: 0;
            .donation-box-text,
            .donation-text-strong,

            .quot-img{
                display: none;
            }
        }
        .donate-now-btn{
            display: none;
        }
        .social-media-links{
            margin: 10px 0px 0px;
        }
        
    }

`;


export const LeftBanner = styled.div`
    width: 100%;
    max-width: 690px;
`;

export const LogoTitle = styled.div`
    display: flex;
    gap:15px;
`;

export const LogoImage = styled.div`
    background: #F7F7F7;
    box-shadow: 0px 10px 20px #0000001A;
    border-radius: 10px;
    opacity: 1;
    width: 120px;
    min-width:120px;
    height: 120px;
    img{
        width:100%;
    } 
`;
export const TitleSection = styled.div``;

export const SearchTitle = styled.h1`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:22px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 15px;
    cursor: pointer;
`;

export const AdoptionsList = styled.ul`
    display: flex;
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    gap: 10px;
`;

export const AdoptionsItem = styled.li`
    color: #33A7AE;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 500;
    line-height:23px;
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const IconSpan = styled.span``;

export const ReviewStart = styled.span`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 5px;
`;
export const StarIcon = styled.span`
    display: flex;
`;
export const Review = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;
export const ButtonSection = styled.div`
    display: flex;
    gap: 15px;
    margin-top: 16px;
   .share_donate_btn{
     padding: 11px 29px;
    }
`;

export const WarmCost = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 15px;
    display: flex;
    align-items: center;
    padding: 18px 15px;
    margin-top: 40px;
    gap: 32px;
`;
export const WarmCostLeft = styled.div`
    width: 100%;
    max-width: 318px;
    position: relative;
    &:after {
        position: absolute;
        background: #E1E1E1;
        height: 100%;
        width: 2px;
        content: "";
        right: -17px;
        top: 0;
    }
`;
export const WarmCoastTile = styled.h2`
   color: #33A7AE;
   font-family: "Jost", sans-serif;
   font-size:20px;
   font-weight: 600;
   line-height:30px;
   margin-bottom:5px;
`;
export const SmallText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height:22px;
`;
export const DollarWrapper = styled.div`
    display: flex;
    gap: 9px;
    flex-wrap: wrap;
`;
export const OtherBtn = styled.div`
     color: #000000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    // background:#01606F ;
    box-shadow: 0px 5px 10px #0000000D;
    background: rgb(51 167 174 / 10%);
    border-radius: 10px;
    padding: 14px 16px;
    display: inline-flex;
    max-width: 56px;
    text-align: center;
    justify-content: center;
`;
export const WarnCostRight = styled.div`
    flex:1;
`;